import { triggerLenovoBack } from './lenovoBack'

const DEFAULT_BAIYING_URL = 'https://smbpaasadmin.lenovo.com'
const BAIYING_URL_STORAGE_KEY = 'baiying-url'

function normalizeBaiyingUrl(url?: string) {
  if (!url) {
    return DEFAULT_BAIYING_URL
  }

  try {
    const resolvedUrl = new URL(url)
    resolvedUrl.hash = ''
    resolvedUrl.search = ''
    return resolvedUrl.toString().replace(/\/$/, '')
  } catch {
    return DEFAULT_BAIYING_URL
  }
}

export function setBaiyingBaseUrl(url?: string) {
  const normalizedUrl = normalizeBaiyingUrl(url)
  localStorage.setItem(BAIYING_URL_STORAGE_KEY, normalizedUrl)
  return normalizedUrl
}

export function getBaiyingBaseUrl() {
  return normalizeBaiyingUrl(localStorage.getItem(BAIYING_URL_STORAGE_KEY) || '')
}

export function getSmbLoginHasUrl() {
  return `${getBaiyingBaseUrl()}/#/login/l-has`
}

export function redirectToSmbLoginHas() {
  triggerLenovoBack({
    backUrl: getSmbLoginHasUrl()
  })
}
